import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

import { customToast } from "../../../../components/notify/NotifyContainer";
import { facebookAccSchema } from "../../validations";
import { IFacebookBotInput } from "../types";
import useFbMutation from "./useFbMutation";
import useFbPageQuery from "./useFbPageQuery";

const defaultValues = {
    page_id: "",
    secret: "",
};

const useBindFbFanPageForm = () => {
    const { projectId, characterId } = useParams();

    const { fbFanPageBot } = useFbPageQuery({ characterId });
    const { handleCreate, createLoading, createSuccess } = useFbMutation({ projectId, characterId });

    const methods = useForm<IFacebookBotInput>({
        defaultValues,
        resolver: yupResolver(facebookAccSchema()),
        mode: "all",
    });

    const handleCancel = () => methods.reset();
    const handleSubmit: SubmitHandler<IFacebookBotInput> = async (data) => {
        await handleCreate(data);
    };

    useEffect(() => {
        if (createSuccess) {
            customToast.success("Successful");
        }
    }, [createSuccess, methods]);

    useEffect(() => {
        if (fbFanPageBot) {
            methods.reset({
                page_id: fbFanPageBot.page_id,
                secret: fbFanPageBot.secret,
            });
            return;
        }
        methods.reset(defaultValues);
    }, [methods, fbFanPageBot]);

    return { methods, handleSubmit, createLoading, createSuccess, handleCancel, isBindFb: !!fbFanPageBot };
};
export default useBindFbFanPageForm;
